'use client';

import useAutenticacaoAcoes from '@/hooks/useAutenticacaoACoes';
import {
  listarMeusGiftCards,
  listarMinhasAssinaturas,
} from '@/services/pedidos';
import { AssinaturaPedido, GiftCardPedido } from '@/services/types/pedidos';
import {
  createContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from 'react';

interface MeusPedidosDataType {
  giftCards: Array<GiftCardPedido> | null;
  setGiftCards: Dispatch<SetStateAction<GiftCardPedido[] | null>>;
  // eslint-disable-next-line no-unused-vars
  recuperarMeusGiftCards: (filtros?: string) => Promise<void>;
  assinaturas: Array<AssinaturaPedido> | null;
  setAssinaturas: Dispatch<SetStateAction<AssinaturaPedido[] | null>>;
  // eslint-disable-next-line no-unused-vars
  recuperarMinhasAssinaturas: (filtros?: string) => Promise<void>;
  recuperandoValores: boolean;
}

export const MeusPedidosDataContext = createContext<
  MeusPedidosDataType | undefined
>(undefined);

export const MeusPedidosDataProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [recuperandoValores, setRecuperandoValores] = useState<boolean>(false);

  const [giftCards, setGiftCards] = useState<Array<GiftCardPedido> | null>(
    null,
  );
  const [assinaturas, setAssinaturas] =
    useState<Array<AssinaturaPedido> | null>(null);

  const { deslogar } = useAutenticacaoAcoes();

  async function recuperarMeusGiftCards(filtros?: string) {
    if (giftCards?.length || recuperandoValores) return;
    setRecuperandoValores(true);
    const meusPedidosDataFromServer = await listarMeusGiftCards(
      filtros ? { filtros } : {},
    );

    if (
      typeof meusPedidosDataFromServer.autenticado === 'boolean' &&
      !meusPedidosDataFromServer.autenticado
    )
      return deslogar();

    setGiftCards(meusPedidosDataFromServer.dados.lista);
    setRecuperandoValores(false);
  }

  async function recuperarMinhasAssinaturas(filtros?: string) {
    if (assinaturas?.length || recuperandoValores) return;
    setRecuperandoValores(true);
    const minhasAssinaturasFromServer = await listarMinhasAssinaturas(
      filtros ? { filtros } : {},
    );

    if (
      typeof minhasAssinaturasFromServer.autenticado === 'boolean' &&
      !minhasAssinaturasFromServer.autenticado
    )
      return deslogar();

    setAssinaturas(minhasAssinaturasFromServer?.dados?.lista);
    setRecuperandoValores(false);
  }

  return (
    <MeusPedidosDataContext.Provider
      value={{
        giftCards,
        setGiftCards,
        recuperarMeusGiftCards,
        assinaturas,
        setAssinaturas,
        recuperarMinhasAssinaturas,
        recuperandoValores,
      }}
    >
      {children}
    </MeusPedidosDataContext.Provider>
  );
};
